import { actions } from '../actions';
import { PERIODS } from 'components/PeriodPicker/periods/constants';

const initialState = {
  dates: {
    to: null,
    from: null
  },
  selectedIterationId: null,
  selectedPeriodKey: PERIODS.ITERATIONS.periodKey,
  selectedTeamId: null,
  snackBar: {
    isOpen: false,
    options: {}
  },
  defaultBoard: null,
  isProcessingRepos: false,
  isBlurred: false,
  hasNoData: false,
  hasIterations: true,
  selectedTeamChangedFromTopBar: false,
  sidebar: {
    isWide: false
  }
};

export const uiStateReducer = (state = initialState, action) => {
  switch (action.type) {
    // --
    // Onboarding flow states
    // --
    case actions.SELECT_TEAM_ID: {
      return {
        ...state,
        selectedTeamId: action.payload
      };
    }

    // ---
    // Date picker
    // ---
    case actions.DATE_SELECTION_CHANGED: {
      return {
        ...state,
        dates: { from: action.payload.start_date, to: action.payload.end_date },
        displayName: action.payload.name,
        computedName: action.payload.computedName
      };
    }
    case actions.TOGGLE_SNACKBAR: {
      const shouldOpen =
        action.payload.isOpen === undefined
          ? !state.snackBar.isOpen
          : action.payload.isOpen;
      return {
        ...state,
        snackBar: {
          isOpen: shouldOpen,
          options: !shouldOpen ? {} : action.payload
        }
      };
    }
    case actions.GET_DEFAULT_BOARD_SUCCEED: {
      return {
        ...state,
        defaultBoard: action.payload
      };
    }
    case actions.SET_DEFAULT_BOARD_SUCCEED: {
      return {
        ...state,
        defaultBoard: action.payload
      };
    }
    case actions.SELECT_ITERATION_ID:
      return {
        ...state,
        selectedIterationId: action.payload
      };
    case actions.SELECT_PERIOD_KEY:
      return {
        ...state,
        selectedPeriodKey: action.payload
      };
    case actions.SET_IS_PROCESSING_REPOS: {
      return {
        ...state,
        isProcessingRepos: action.payload
      };
    }
    case actions.SET_IS_BLURRED: {
      return {
        ...state,
        isBlurred: action.payload
      };
    }
    case actions.SET_HAS_NO_DATA: {
      return {
        ...state,
        hasNoData: action.payload
      };
    }
    case actions.SET_HAS_ITERATIONS: {
      return {
        ...state,
        hasIterations: action.payload
      };
    }
    case actions.TOGGLE_SIDEBAR: {
      return {
        ...state,
        sidebar: {
          isWide: action.payload
        }
      };
    }
    case actions.SET_SELECTED_TEAM_CHANGED_FROM_TOPBAR: {
      return {
        ...state,
        selectedTeamChangedFromTopBar: action.payload
      };
    }
    default:
      return state;
  }
};
